// extracted by mini-css-extract-plugin
module.exports = {"tableWrap":"EnrolledClinics_tableWrap__1wSyY","actionsCol":"EnrolledClinics_actionsCol__rAPza"};